import { Component, OnInit, ElementRef, ViewChild, ChangeDetectorRef } from '@angular/core';
import { SubmissionsService } from '../_services/submissions.service';
import { Submission, SubmissionMethod, CoveragesObject } from '../_models/submission';
import { SUBMISSION_MSGS, PRODUCT_CONFIG, FORM_MSGS } from 'src/app/_common/product-config';
import { NgbCalendar, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-submission-coverage',
  templateUrl: './submission-coverage.component.html',
  styleUrls: ['./submission-coverage.component.scss']
})
export class SubmissionCoverageComponent implements OnInit {

  private submissionCoverage: Submission;
  private submissionData;
  private submissionMethod: SubmissionMethod = new SubmissionMethod();
  
  private loading:boolean = false;
  private productLoading:boolean = false;
  private isSubmitted: boolean = false;
  
  private productConfig = PRODUCT_CONFIG; //Using it in HTML
  private submissionMsgs = SUBMISSION_MSGS; //Using it in HTML
  private formMsgs = FORM_MSGS; //Using it in HTML
  private referenceData; //Using it in HTML

  private effectiveMinDate = {};
  private effectiveMaxDate = {};
  private expirationMinDate = {};
  
  @ViewChild("coverageForm", {static: false}) coverage: NgForm;
  constructor(private submissionService: SubmissionsService, private el: ElementRef, private calendar: NgbCalendar, private formatter: NgbDateParserFormatter, private changeDetector: ChangeDetectorRef) { }

  ngOnInit() {
    this.submissionCoverage = this.getSubmission();
    this.submissionData = this.submissionCoverage.submissionData;
    
    this.referenceData = this.submissionService.referenceData;

    let _effectiveMinDate = new Date();
    let _effectiveMaxDate = new Date();
    _effectiveMaxDate.setDate(_effectiveMaxDate.getDate() + PRODUCT_CONFIG.SubmissionEffectiveDateRange + 1);
    this.effectiveMinDate =  {year: _effectiveMinDate.getFullYear(), month: _effectiveMinDate.getMonth()+1, day: _effectiveMinDate.getDate()};
    this.effectiveMaxDate =  {year: _effectiveMaxDate.getFullYear(), month: _effectiveMaxDate.getMonth()+1, day: _effectiveMaxDate.getDate()};
  }
  ngAfterViewInit(){
    if(this.submissionData.policyEffectiveDate!=null && this.submissionData.policyEffectiveDate!="" && this.coverage){
      this.coverage["effectiveDate"]=this.submissionData.policyEffectiveDate;
      this.changeDetector.detectChanges();
    }
    if(this.submissionData.policyExpirationDate!=null && this.submissionData.policyExpirationDate!="" && this.coverage){
      this.coverage["expirationDate"]=this.submissionData.policyExpirationDate;
      this.changeDetector.detectChanges();
    }
    if(this.submissionData.policyNeedByDate!=null && this.submissionData.policyNeedByDate!="" && this.coverage){
      this.coverage["needByDate"]=this.submissionData.policyNeedByDate;
      this.changeDetector.detectChanges();
    }
  }

  getSubmission(){
    return this.submissionService.submission;
  }

  onEffectiveDateSelect(_event){
    if(_event!=null){
      this.submissionData.policyEffectiveDate = this.formatter.format(_event); //new Date(this.formatter.format(_event));//new Date(_event.year, _event.month-1, _event.day);
      let _expirationDate = new Date(this.submissionData.policyEffectiveDate);
      _expirationDate.setFullYear(_expirationDate.getFullYear()+1);
      let _expirationDateObj =  {year: _expirationDate.getFullYear(), month: _expirationDate.getMonth()+1, day: _expirationDate.getDate()};
      this.submissionData.policyExpirationDate = this.formatter.format(_expirationDateObj);
      this.coverage["expirationDate"]=this.submissionData.policyExpirationDate;
      this.loadProducts();
    }else{
      this.submissionData.policyEffectiveDate = this.formatter.format(this.formatter.parse(this.coverage["effectiveDate"]));
    }
    let _expirationMinDate = new Date(this.submissionData.policyEffectiveDate);
    this.expirationMinDate =  {year: _expirationMinDate.getFullYear(), month: _expirationMinDate.getMonth()+1, day: _expirationMinDate.getDate()};
  }

  onExpirationDateSelect(_event){
    if(_event!=null){
      this.submissionData.policyExpirationDate = this.formatter.format(_event); //new Date(this.formatter.format(_event));//new Date(_event.year, _event.month-1, _event.day);
    }else{
      this.submissionData.policyExpirationDate = this.formatter.format(this.formatter.parse(this.coverage["expirationDate"]));
    }
  }

  onNeedByDateSelect(_event){
    if(_event!=null){
      this.submissionData.policyNeedByDate = this.formatter.format(_event); //new Date(this.formatter.format(_event));//new Date(_event.year, _event.month-1, _event.day);
    }else{
      this.submissionData.policyNeedByDate = this.formatter.format(this.formatter.parse(this.coverage["needByDate"]));
    }
  }

  //Load Coverages(Products) to show as checkboxes on screen.
  loadProducts(){
    this.productLoading = true;
    this.submissionData.coverages = [];
    this.submissionCoverage.allCoverages = [];

    this.submissionCoverage.underwriters = [];
    this.submissionCoverage.underwriter = "";

    let requestPayload = {"nicheName": this.submissionData.niche, "producerCodes": [this.submissionData.producerCode], "effectiveDate": this.submissionData.policyEffectiveDate};
    this.submissionService.productsUnderwriters(requestPayload).subscribe((data)=>{
      this.productLoading = false;
      console.log(data);
      if(data && data.length > 0){
        data.forEach(_data => {
          if(_data && _data.products && _data.products.length > 0){
            _data.products.forEach(product => {
              let coverage = new CoveragesObject();
              coverage.lobName = product.lobName;
              coverage.niche = product.nicheName;
              coverage.productName = product.productName;
              coverage.productDescription = product.productDescription;
              coverage.indicator = product.primaryExcessIndicator;
              coverage.businessEntity = product.businessEntityName;
              coverage.customerSegment = product.customerSegmentName;
              coverage.underwriters = product.underwriters;
      
              this.submissionCoverage.allCoverages.push(coverage);
            });
          }
        });
      }
    }, error=>{
      this.productLoading = false; 
      this.submissionService.openModal('error', '');
    });
  }

  onSelectCoverage(_isChecked, _coverage){
    this.submissionCoverage.underwriter = "";
    this.submissionCoverage.underwriters = [];

    _coverage.isSelected = _isChecked;
    if(_isChecked){
      this.submissionData.coverages.push(_coverage);
    }else{
      let index = this.submissionData.coverages.findIndex((_subCoverage)=>{ return _subCoverage.productName === _coverage.productName});

      this.submissionData.coverages.splice(index,1);
    }
    
    this.submissionData.coverages.forEach(coverage => {
      if(coverage.isSelected){
        coverage.underwriters.forEach(_underwriter => {
          let underwriterIndex = this.submissionCoverage.underwriters.findIndex((_subUnderwriter:any)=>{return _subUnderwriter.underwriterEmailAddress ===_underwriter.underwriterEmailAddress});

          if(underwriterIndex==-1){
            this.submissionCoverage.underwriters.push(_underwriter);
          }        
        });
      }
    });

    if(this.submissionCoverage.underwriters.length==1){
      this.submissionCoverage.underwriter = this.submissionCoverage.underwriters[0];
    }else if(this.submissionCoverage.underwriters.length==0){
      this.submissionCoverage.underwriter = "";
    }
  }

  onContinue():boolean{
    this.isSubmitted = true;

    const formGroupInvalid = this.el.nativeElement.querySelectorAll('.ng-invalid:not(form)');
    if(formGroupInvalid.length>0){
      (<HTMLInputElement>formGroupInvalid[0]).focus();
      return;
    }

    if(this.submissionCoverage.underwriters.length>0 && !this.submissionCoverage.underwriter){
      return;
    }

    this.submissionData.underwriter = this.submissionCoverage.underwriter.underwriterName;

    console.log(this.submissionCoverage);
    return (this.coverage.valid && this.submissionData.coverages && this.submissionData.coverages.length>0);
  }
}
